import { useState, useCallback } from "react";
import { updateOrderNoteURL } from "../../utils/ConstantsURL";

export const useUpdateSingleNoteOrder = (token) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const bulkReorderNotes = useCallback(async (id_seccion, id_documento, ids) => {
    setIsLoading(true);
    setError(null);

    const seccionNum = Number(id_seccion);
    const docNum = Number(id_documento);
    const idsNum = Array.isArray(ids) ? ids.map((id) => Number(id)).filter((id) => !isNaN(id) && id > 0) : [];

    if (!seccionNum || isNaN(seccionNum) || !docNum || isNaN(docNum) || idsNum.length === 0) {
      const msg = `Parámetros inválidos para reordenar: id_seccion=${id_seccion}, id_documento=${id_documento}, ids=${JSON.stringify(ids)}`;
      console.error(msg);
      setError(msg);
      setIsLoading(false);
      return { success: false, message: msg };
    }

    try {
      const response = await fetch(updateOrderNoteURL(), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          id_seccion: seccionNum,
          id_documento: docNum,
          ids: idsNum,
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Error al actualizar el orden de las notas");
      }

      return result;
    } catch (err) {
      console.error("Error bulk reordering notes:", err);
      setError(err.message);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  return {
    bulkReorderNotes,
    updateSingleNoteOrder: bulkReorderNotes,
    isLoading,
    error,
  };
};

export const useBulkReorderNotes = useUpdateSingleNoteOrder;
